import { LinkedColumnType } from '@/features/canvas/types/linkage';
import { transformPercentageToInteger } from '@/features/canvas/utils/transform-percentage-to-integer';

import {
  truncateFilterValue,
  truncateMultiLineField,
  truncateSingleLineField,
  truncateTitle,
} from './truncate-field-value';

export const getTransformedLinkedValue = (value: string, type: keyof typeof LinkedColumnType) => {
  if (!value) return value;

  const trimmedValue = value.trim();

  switch (type) {
    case LinkedColumnType.title:
      return truncateTitle(trimmedValue);

    case LinkedColumnType.description:
      return truncateMultiLineField(trimmedValue);

    case LinkedColumnType.small:
      return truncateSingleLineField(trimmedValue);

    case LinkedColumnType.big:
      return truncateMultiLineField(trimmedValue);

    case LinkedColumnType.filter:
    case LinkedColumnType.createNewFilter:
      return truncateFilterValue(trimmedValue);

    case LinkedColumnType.progressBar:
      return transformPercentageToInteger(trimmedValue).toString();

    case LinkedColumnType.budgetTotal:
    case LinkedColumnType.budgetCapEx:
    case LinkedColumnType.budgetOpEx:
    case LinkedColumnType.budgetSpent:
      return trimmedValue;

    default:
      return trimmedValue;
  }
};
